<template lang="pug">
el-form(ref='judgmentForm', :inline='false', :model='precheckerJudgment', label-width='150px')
  el-form-item(label='Γλώσσα Αίτησης')
    span() {{selectedLanguage}}
  //- el-form-item(v-if='!this.workingApplication.protocol' label='Αρ. πρωτ.')
  //-   el-button(type='secondary', size="small" @click='defineProtocol()') Ορισμός Α.Π.
  el-form-item(label='Εκκρεμότητες' v-if="!isPostExam")
    el-checkbox(
      v-model='precheckerJudgment.pending',
      @change='togglePending',
      label='Υπάρχουν Εκκρεμότητες',
      border=''
    )
  div
    el-form-item(label='Θεματική περιοχή' v-if="!isReappraisal && !isPostExam")
      el-select.big(v-model='precheckerJudgment.academicField.name', placeholder='Θεματική Περιοχή',
        @change='toggleAcademicField', filterable)
        el-option(v-for="area in academicAreas", :key="area.id", :label="area.name",
          :value="area.id")
    el-form-item(label='Θεματική περιοχή' v-if="isReappraisal || isPostExam")
      span(v-if="academicField") {{ academicField.name }}
    el-form-item(v-if="isReappraisal && this.workingApplication.overdue")
      el-alert(:closable='false' type='warning' :title="OVERDUE_MESSAGE" show-icon=''
        style="border: 1px solid; background-color: #fdf6ec;")
  hr
  el-form-item(label='Γλώσσα Χρήστη' v-if="language !== null") {{ language }}
  el-form-item(label='Αιτησεις Χρήστη')
    span(v-html='calcAllApps')
  el-form-item(label='Σχόλιο προς Χρήστη' v-if="!isPostExam")
    span(v-html='generalJudgment')
  div
    el-form-item(label='Σχόλια Εγγράφων' v-if="!isPostExam")
      span(v-html='completeDocJudgment')
  hr
  internalComments
  el-form-item(label='Εσωτερικό Σχόλιο')
    el-input.biggest(
      type='textarea', :autosize='{ minRows: 4, maxRows: 10}',
      placeholder='Εισάγετε κείμενο για εσωτερική κατανάλωση',
      @dblclick.native='addText',
      v-model='precheckerJudgment.internalComment',
      @change='modifyInternalComment'
    )
  el-form-item(label='Σχόλιο Αναδρομολόγησης', v-if='rerouteExists')
    el-input.rerouteComment(
      type='textarea',
      v-model='rerouteCom',
      size='100',
      :disabled='true',
      :autosize='{ minRows: 4, maxRows: 10 }'
    )
  el-dialog(title='Συνήθεις Προτάσεις', :visible.sync='addTextdialogVisible', width='90%')
    div(v-for='recom in recommendations',
      :key='recom.id',
      :value='{id: recom.id, name: recom.description}',
      :label='recom.description'
    )
      div
        label
          input(
            type='checkbox',
            @change='toggleText(recom.id, recom.description, $event.target.checked)',
            :value='recom.description',
            :checked='false'
          )
          | {{recom.description}}
    span.dialog-footer(slot='footer')
      el-button(@click='addTextdialogVisible = false') Άκυρο
      el-button(type='primary', @click='addTextToComment') Επιβεβαίωση
  el-form-item(label='Στην Αναμονή')
    el-checkbox(v-model='precheckerJudgment.queue', @change='toggleQueue',
      label='Ναι', border='')
  el-form-item(label='Χρώμα')
    el-input(placeholder='Εισάγετε χρώμα', v-model='precheckerJudgment.color')
  hr
  div
  el-form-item(label='Βεβαίωση από Π.Ι.' v-if="isPostExam")
    el-upload(
      v-loading='this.uploadingExamResults',
      class='upload-demo',
      ref='uploadExamsRef',
      accept='.jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF',
      :file-list='examResultsAttachments',
      :http-request='addExamResultsAttachment',
      :on-preview="handlePreview",
      :on-remove='handleExamResultsRemove',
      :before-remove='handleBeforeRemove',
      :limit=1
      action='',
      :auto-upload='true',
      :show-file-list='true'
    )
      el-button(
        slot='trigger' size='small' type='primary' :disabled='examResultsAttachments.length >= 1') Ανέβασμα
      div(class='el-upload__tip', slot='tip')
        |** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα Βεβαίωσης αποτελεσμάτων από Πανεπιστημιακό Ίδρυμα (Ένα αρχείο pdf μεγέθους μέχρι 12MB)
  el-form-item(label='Επιπλέον έγγραφο')
    el-upload(
      v-loading='this.uploadingAdditional',
      class='upload-demo',
      ref='uploadPrecheckerRef',
      accept='.jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF',
      :file-list='precheckerAttachments',
      :http-request='addAdditionalAttachment',
      :on-preview="handlePreview",
      :on-remove='handleAdditionalRemove',
      :before-remove='handleBeforeRemove',
      action='',
      :auto-upload='true',
      :show-file-list='true'
    )
      el-button(slot='trigger' size='small' type='primary') Ανέβασμα
      div(class='el-upload__tip', slot='tip')
        |** ΑΠΟΚΛΕΙΣΤΙΚΑ για ανέβασμα επιπλέον δικαιολογητικών της αίτησης (Ένα αρχείο pdf μεγέθους μέχρι 12MB)
  el-form-item(label='Επιλογή Χειριστή')
    el-select(v-model='precheckerJudgment.assignedTo.uid', filterable='', placeholder='Παρακαλώ Επιλέξτε', @change='toggleSpecialProponent')
        el-option(v-for='specialProponent in specialProponents', :key='specialProponent.id', :label="specialProponent.firstname + ' ' + specialProponent.surname", :value='specialProponent.id', filterable='')
  el-form-item(label='Ανάθεση σε' v-if="false && this.isReappraisal && !this.isSecondReappraisal && !this.workingApplication.overdue && !precheckerJudgment.pending")
    el-select(v-model='precheckerJudgment.assignedTo.role' placeholder='Παρακαλώ Επιλέξτε')
      el-option(label='Αντιπρόεδρο Α' value='VicePresidentA')
      el-option(label='Αντιπρόεδρο Β' value='VicePresidentB')
      //- el-option(label='Πρόεδρο' value='President')
  el-form-item(label='')
    el-checkbox(
      label='Επιθυμώ να ακυρώσω την αίτηση',
      v-model='releaseChecked',
      @change='toggleRelease'
    )
  el-form-item
    el-tooltip.item(effect='dark' placement='top')
      div(slot='content')
        | Χρειάζεται απαραίτητα προσωρινή αποθήκευση της αίτησης
        br
        |  για να ανοίξει ο διάλογος
      el-checkbox(label='Άνοιγμα διαλόγου με πολίτη' v-model='communicationActive' v-if="!isPostExam")
  //- el-form-item(label="editor")
  //-   vue-editor(v-model='content')
  hr
  div(style='text-align: center')
    span(style='text-align: left')
      el-tooltip.item(effect='dark', placement='top')
        div(slot='content')
          | Προσοχή! Η αίτηση θα απενεργοποιηθεί μόνιμα
          br
          | και πρέπει να έχετε ανεβάσει δικαιολογητικό
          br
          | ή σχετικό σχόλιο
        el-popover(placement='top' width='360' v-model='showRelease')
          p Είστε σίγουροι ότι θέλετε να την απενεργοποιήσετε; Αν ναι το σχόλιο για τον λόγο της απενεργοποίησης είναι υποχρεωτικό!
          div(style='text-align: right; margin: 0')
            el-input(placeholder="Σχόλιο Αποδέσμευσης", v-model="releaseComment", type="textarea")
            p
              el-button(size='mini', type='text', @click='showRelease = false')
                | Άκυρο
              el-button(
                type='primary', size='mini',
                @click='deactivateApplication',
                :disabled='disableRelease'
              ) Αποστολή
          el-button(slot='reference', style='margin-right: 150px', size='mini', type='warning', round='',
            @click='showRelease = true',  :disabled="!releaseChecked") Ακύρωση αίτησης
    //- el-button(size='mini', type='primary', round='', @click='testRefresh()', :disabled='false') refresh
    el-button(size='mini', type='primary', round='', @click='tempSave',  :disabled="releaseChecked")
      |Προσωρινή Αποθήκευση
    //- el-button(size='mini', type='warning', plain, round='', @click='createPdf') Δημιουργία PDF
    el-button(size='mini', type='danger', round='', @click='finalSave', :disabled='!isValid || releaseChecked')
      |Οριστική Υποβολή
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import internalComments from '../common/internalComments'
import sharedMethods from '../common/sharedMethods.js'
import { VueEditor } from 'vue2-editor'
import dictionary from '../../store/dictionary'

const ATTACHMENT_TYPE_ADDITIONAL = 21
const ATTACHMENT_TYPE_EXAM_RESULTS = 2007

export default {
  components: {
    internalComments,
    VueEditor,
    dictionary
  },
  mixins: [sharedMethods],
  mounted: function () {
    this.$store.dispatch('LOAD_ACADEMIC_AREAS')
  },
  props: ['specialProponents', 'judgementDocs', 'attachedDocumentsTable', 'generalComment',
    'generalCommentWorking', 'recommendations', 'isReappraisal', 'isPostExam', 'isSecondReappraisal'],
  data () {
    return {
      communicationActive: false,
      releaseComment: '',
      showRelease: false,
      content: '<h1>Συμπληρώστε το σχόλιο σας</h1>',
      checkedTexts: [],
      addTextdialogVisible: false,
      uploadingExamResults: false,
      uploadingAdditional: false,
      generalJudgment: this.generalCommentWorking,
      appFinalSaved: false,
      modified: false,
      academicFieldCommentActive: false,
      releaseChecked: false,
      vicePresidentAssigned: null
    }
  },
  methods: {
    modifyCommunicationExternal () {
      const lastStep = this.workingApplication.applicationHistory.slice(-1)[0]
      if (['precheckerW_'].includes(lastStep.applicationStatus)) {
        this.communicationActive = lastStep.judgment.communicationActive || false
      }
    },
    toggleSpecialProponent (val) {
      this.precheckerJudgment.assignedTo.uid = val
    },
    toggleRelease (val) {
      if (this.releaseChecked) {
        this.$notify.warning({
          title: 'Προειδοποίηση',
          message: 'Προσοχή! Η αίτηση θα απενεργοποιηθεί μόνιμα και πρέπει να έχετε ανεβάσει σχετικό δικαιολογητικό',
          offset: 300
        })
      }
    },
    deactivateApplication () {
      const payload = {
        judgment: {
          pending: this.precheckerJudgment.pending,
          pendingReason: `${this.generalComment} <hr> ${this.judgementDocs}`,
          academicField: {
            id: this.academicField.id,
            name: this.academicField.name
          },
          internalComment: this.releaseComment,
          attachedDocuments: this.attachedDocumentsTable,
          assignedTo: {
            role: null,
            uid: null
          }
        }
      }
      axios.post(
        `${this.BASE_URL}/precheckers/uid/applications/${this.workingApplication.id}/deactivation`, payload
      ).then((response) => {
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
        this.frontEndSuccessMsg('Η αίτηση απενεργοποιήθηκε με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την απενεργοποίηση της αίτησης')
        this.catchError(err)
      })
    },
    catchError (err) {
      this.backendError(err)
      throw err
    },
    toggleText (id, text, state) {
      state ? this.checkedTexts.push(text) : this.checkedTexts = this.checkedTexts.filter(delText => delText !== text)
    },
    addTextToComment () {
      this.addTextdialogVisible = false
      this.precheckerJudgment.internalComment =
        this.precheckerJudgment.internalComment
          ? this.precheckerJudgment.internalComment + '\n' + this.checkedTexts.reduce((acc, cur) => acc + '\n' + cur)
          : this.checkedTexts.reduce((acc, cur) => acc + '\n' + cur)
      this.checkedTexts = []
    },
    addText () {
      this.fromInput = 'generalComment'
      this.addTextdialogVisible = true
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    addExamResultsAttachment (file, fileList) {
      this.addAttachment(file, ATTACHMENT_TYPE_EXAM_RESULTS, this.examResultsAttachments, 'SET_EXAM_RESULTS_ATTACHMENTS', 'uploadingExamResults')
    },
    addAdditionalAttachment (file, fileList) {
      this.addAttachment(file, ATTACHMENT_TYPE_ADDITIONAL, this.precheckerAttachments, 'SET_PRECHECKER_ATTACHMENTS', 'uploadingAdditional')
    },
    addAttachment (file, attachmentType, attachmentsList, dispatchType, loading) {
      this[loading] = true
      return this.getData(file.file).then(data => {
        const url = `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments`
        let payload = {
          type: attachmentType,
          file: data,
          name: file.file.name,
          uuid: this.currentUser.id
        }
        return axios.post(url, payload)
          .then(res => {
            let id = res.data.data.id
            file.file.id = id
            this.frontEndSuccessMsg('Η προσθήκη του εγγράφου πραγματοποιήθηκε με επιτυχία')
            this[loading] = false
            let attachedDocs = attachmentsList.slice(0)
            attachedDocs[attachedDocs.length] =
              {type: payload.type, name: payload.name, uid: payload.uuid, id: id}
            this.$store.dispatch(dispatchType, attachedDocs)
          }).catch(err => {
            this.frontEndError('Σφάλμα κατά την μεταφόρτωση του εγγράφου')
            this.catchError(err)
            this[loading] = false
          })
      })
    },
    handleExamResultsRemove (file, fileList) {
      this.handleRemove(file, this.examResultsAttachments, 'SET_EXAM_RESULTS_ATTACHMENTS', 'uploadingExamResults')
    },
    handleAdditionalRemove (file, fileList) {
      this.handleRemove(file, this.precheckerAttachments, 'SET_PRECHECKER_ATTACHMENTS', 'uploadingAdditional')
    },
    handleRemove (file, attachmentsList, dispatchType, loading) {
      this[loading] = true
      const url = `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments/${file.id}`
      return axios.delete(url)
        .then(response => {
          this.frontEndSuccessMsg('Το έγγραφο αφαιρέθηκε')
          this[loading] = false
          this.$store.dispatch(dispatchType, attachmentsList.filter(attachment => attachment.id !== file.id))
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την αφαίρεση του εγγράφου')
          this.catchError(err)
          this[loading] = false
        })
    },
    handlePreview (file) {
      // let pdfWindow = window.open('')
      // pdfWindow.document.write(`<p>Downloading ${file.type} with name ${file.name}...</p>`)
      axios.get(
        `${this.BASE_URL}/users/uid/applications/${this.workingApplication.id}/attachments/${file.id}`
      ).then((response) => {
        const base64Data = encodeURI(response.data.data.file[0])
        this.openPdfWindow(file.name + ' (' + file.id + ')', base64Data)
        // window.open('data:application/pdf;base64,' + response.data.data.file[0])
      })
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name}？`)
    },
    // testRefresh () {
    //   try {
    //     const response = this.$store.dispatch('refresh')
    //     return axios(response)
    //   } catch (error) {
    //     // All Vuex modules must logout here
    //     this.$store.dispatch('logout')
    //     return Promise.reject(error)
    //   }
    // },
    // createPdf () {
    //   let pdfWindow = window.open('')
    //   pdfWindow.document.write(`<p>Creating precheckerJudgment...</p>`)
    //   axios.post(
    //     'https://gateway.interoperability.gr/e-doatap/2.00/createPDF',
    //     {
    //       FileName: 'precheckerJudgment.pdf',
    //       HTMLString: this.htmlTemplate
    //     }
    //   ).then((response) => {
    //     pdfWindow.document.write('<p>Done</p>')
    //     pdfWindow.document
    //       .write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
    //         encodeURI(response.data.Base64) + "'></iframe>")
    //   })
    // },
    finalSave () {
      let payload
      if (!this.isReappraisal && !this.isPostExam) {
        payload = {
          judgment: {
            pending: this.precheckerJudgment.pending,
            pendingReason: `${this.generalComment} <hr> ${this.judgementDocs}`,
            academicField: {
              id: this.precheckerJudgment.academicField.id,
              name: this.precheckerJudgment.academicField.name
            },
            internalComment: this.precheckerJudgment.internalComment,
            attachedDocuments: this.attachedDocumentsTable,
            assignedTo: {
              role: 'SpecialProponent',
              uid: this.precheckerJudgment.assignedTo.uid
            }
          }
        }
      } else if (this.isReappraisal || this.isPostExam) {
        if (!this.precheckerJudgment.pending) {
          // if (this.workingApplication.overdue || this.isSecondReappraisal) {
          //   this.precheckerJudgment.assignedTo.role = 'President'
          // }
          this.precheckerJudgment.assignedTo.role = 'SpecialProponent'
        } else {
          this.precheckerJudgment.assignedTo.role = null
          this.precheckerJudgment.assignedTo.uid = null
        }
        payload = {
          judgment: {
            pending: this.precheckerJudgment.pending,
            pendingReason: `${this.generalComment} <hr> ${this.judgementDocs}`,
            internalComment: this.precheckerJudgment.internalComment,
            attachedDocuments: this.attachedDocumentsTable,
            assignedTo: {
              role: this.precheckerJudgment.assignedTo.role,
              uid: this.precheckerJudgment.assignedTo.uid
            }
          }
        }
      }
      this.$confirm(this.saveMessage,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.put(
          `${this.BASE_URL}/precheckers/uid/applications/${this.workingApplication.id}/final`, payload
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    tempSave () {
      let payload
      if (!this.isReappraisal && !this.isPostExam) {
        payload = {
          judgment: {
            communicationActive: this.communicationActive,
            pending: this.precheckerJudgment.pending,
            pendingReason: this.generalComment,
            academicField: {
              id: this.precheckerJudgment.academicField.id,
              name: this.precheckerJudgment.academicField.name
            },
            internalComment: this.precheckerJudgment.internalComment,
            queue: this.precheckerJudgment.queue,
            color: this.precheckerJudgment.color,
            attachedDocuments: this.attachedDocumentsTable,
            assignedTo: {
              role: 'SpecialProponent',
              uid: this.precheckerJudgment.assignedTo.uid
            }
          }
        }
      } else if (this.isReappraisal || this.isPostExam) {
        if (!this.precheckerJudgment.pending) {
          // if (this.workingApplication.overdue || this.isSecondReappraisal) {
          //   this.precheckerJudgment.assignedTo.role = 'President'
          // }
          this.precheckerJudgment.assignedTo.role = 'SpecialProponent'
        } else {
          this.precheckerJudgment.assignedTo.role = null
          this.precheckerJudgment.assignedTo.uid = null
        }
        payload = {
          judgment: {
            pending: this.precheckerJudgment.pending,
            pendingReason: this.generalComment,
            internalComment: this.precheckerJudgment.internalComment,
            assignedTo: {
              role: this.precheckerJudgment.assignedTo.role,
              uid: this.precheckerJudgment.assignedTo.uid
            },
            queue: this.precheckerJudgment.queue,
            color: this.precheckerJudgment.color,
            attachedDocuments: this.attachedDocumentsTable
          }
        }
      }
      axios.put(
        `${this.BASE_URL}/precheckers/uid/applications/${this.workingApplication.id}/temp`, payload
      ).then((response) => {
        this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
        this.$store.dispatch('LOAD_WORKING_APPLICATION', this.workingApplication.id)
        this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
        this.catchError(err)
      })
    },
    togglePending (val) {
      this.modified = !(this.precheckerJudgment.pending === this.pending)
      if (this.precheckerJudgment.pending) {
        this.precheckerJudgment.assignedTo.role = null
        console.log('this.precheckerJudgment.assignedTo.role', this.precheckerJudgment.assignedTo.role)
      }
    },
    toggleQueue (val) {
    },
    toggleAcademicField (val) {
      this.academicFieldCommentActive = (val === 'other')
      let name = this.academicAreas.find(area => area.id === val).name
      if (val !== 'other') {
        this.precheckerJudgment.academicField = {id: val, name: name}
      }
      this.modified = !(this.precheckerJudgment.academicField === this.academicField)
    },
    modifypendingReason (val) {
      this.modified = !(this.precheckerJudgment.pendingReason === this.comment)
    },
    modifyInternalComment (val) {
      this.modified = !(this.precheckerJudgment.internalComment === this.internalComment)
    }
  },
  computed: {
    appId () {
      this.modifyCommunicationExternal()
      return this.workingApplication.id
    },
    calcAllApps () {
      return this.workingApplication.usersAllApplications.length === 1
        ? 'Ο χρήστης έχει μόνο μια αίτηση στο σύστημα'
        : '<b>ΠΡΟΣΟΧΗ</b> ο χρήστης έχει συνολικά τις παρακάτω αιτήσεις: ' +
          this.workingApplication.usersAllApplications.map(app => {
            return `<div>${app.protocol}: ${app.grApplicationType} στην κατάσταση: ${dictionary[app.applicationStatus]}</div>`
          }).join('')
          //   return `<div>${app.id}: ${app.grApplicationType} στην κατάσταση: ${dictionary[app.applicationStatus]}</div>`
          // }).join('')
    },
    disableRelease () {
      return this.releaseComment.length < 5
    },
    language () {
      return this.workingApplication.language
        ? this.workingApplication.language === 'el'
          ? 'Ελληνικά'
          : 'Αγγλικά'
        : null
    },
    overdue () {
      return this.workingApplication.overdue
        ? 'Ναι'
        : 'Όχι'
    },
    selectedLanguage () {
      return this.workingApplication.language === null
        ? ''
        : this.workingApplication.language === 'en'
          ? 'Αγγλικά'
          : 'Ελληνικά'
    },
    rerouteCom () {
      const history2 = this.workingApplication.applicationHistory.slice(-2)
      return history2[1].reroute === true
        ? history2[0].releaseComment
        : ''
    },
    rerouteExists () {
      return this.workingApplication.applicationHistory.slice(-1)[0].reroute
    },
    isValid () {
      if (!this.isReappraisal && !this.isPostExam) {
        return (this.precheckerJudgment.academicField.id !== null && this.precheckerJudgment.assignedTo.uid !== null) || this.precheckerJudgment.pending
      } else if (this.isReappraisal) {
        // if (this.workingApplication.overdue || this.isSecondReappraisal || this.pending) {
        if (this.pending) {
          return true
        } else {
        //   return this.precheckerJudgment.assignedTo.role !== null
          return this.precheckerJudgment.assignedTo.uid !== null
        }
      } else if (this.isPostExam) {
        return (this.examResultsAttachments.length >= 1 && this.precheckerJudgment.assignedTo.uid !== null)
      }
    },
    saveMessage () {
      if (!this.isReappraisal) {
        return this.precheckerJudgment.pending
          ? `Η αίτηση έχει ΕΚΚΡΕΜΟΤΗΤΕΣ και θα επιστραφεί στον ΠΟΛΙΤΗ. 
            Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;`
          : `Ο φάκελος είναι ΠΛΗΡΗΣ και η αίτηση θα προωθηθεί σε ΧΕΙΡΙΣΤΗ. 
            Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;`
      } else if (this.isReappraisal) {
        return this.precheckerJudgment.pending
          ? `Η αίτηση έχει ΕΚΚΡΕΜΟΤΗΤΕΣ και θα επιστραφεί στον ΠΟΛΙΤΗ. 
            Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;`
          : this.workingApplication.overdue
            ? `Ο φάκελος είναι ΠΛΗΡΗΣ αλλά η αίτηση θα προωθηθεί σε ΧΕΙΡΙΣΤΗ ως ΕΚΠΡΟΘΕΣΜΗ. Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;`
            : `Ο φάκελος είναι ΠΛΗΡΗΣ και η αίτηση θα προωθηθεί σε ΧΕΙΡΙΣΤΗ. Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;`
            // : this.precheckerJudgment.assignedTo.role === 'President'
            //   ? `Ο φάκελος είναι ΠΛΗΡΗΣ και η αίτηση θα προωθηθεί στον/ην ΠΡΟΕΔΡΟ. Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;`
            //   : this.precheckerJudgment.assignedTo.role === 'VicePresidentA' || this.precheckerJudgment.assignedTo.role === 'VicePresidentB'
            //     ? `Ο φάκελος είναι ΠΛΗΡΗΣ και η αίτηση θα προωθηθεί στον/ην ΑΝΤΙΠΡΟΕΔΡΟ. Είστε σίγουροι ότι θέλετε να προβείτε στην οριστική υποβολή της;`
            //     : ` `
      }
    },
    completeDocJudgment () {
      return this.judgementDocs
    },
    precheckerJudgment () {
      return this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === this.activeLane).judgment
        // .find(step => step.applicationStatus === 'precheckerW_').judgment
    },
    pending () {
      return this.precheckerJudgment.pending
    },
    comment () {
      return this.precheckerJudgment.pendingReason
    },
    academicField () {
      if (this.isReappraisal) {
        return this.workingApplication.relevantAppl.academicField
      } else if (this.isPostExam) {
        if (this.workingApplication.relevantApplication.applicationType !== 'reappraisal') {
          return this.workingApplication.relevantAppl.academicField
        } else {
          return this.workingApplication.relevantApplication.relevantAppl.academicField
        }
      } else {
        return this.precheckerJudgment.academicField
      }
    },
    ...mapGetters({ currentUser: 'currentUser' }),
    ...mapState([
      'precheckerAttachments',
      'examResultsAttachments',
      'workingApplication',
      'BASE_URL',
      'activeLane',
      'academicAreas',
      'OVERDUE_MESSAGE'
    ])
  },
  watch: {
    appId: (newVal, oldVal) => {
    },
    workingApplication: {
      handler: function (newVal, oldVal) {
        this.generalJudgment = this.generalComment
      },
      deep: true
    },
    judgementDocs: {
      handler: function (newVal, oldVal) {
      },
      deep: true
    },
    generalComment: {
      handler: function (newVal, oldVal) {
        this.generalJudgment = newVal
      },
      deep: true
    },
    // whenever value changes, this function will run
    pending: (newVal, oldVal) => {
      if (oldVal === true) this.comment = ''
    },
    comment: (newComment, oldComment) => {
      if (newComment === 'the reason for pending') this.comment = ''
    }
  }
}
</script>

<style scoped lang="scss">

.rerouteComment {
  background-color:#f1959d;
  width: 700px;
  padding: 10px;
  & > textarea {
    background-color:rgb(204, 118, 168);
  }
}

.el-checkbox.is-bordered {
  padding: 9px 20px 9px 10px;
  border-radius: 4px;
  border: 1px solid #7da0b8;
}
.el-input {
  width: 240px;
}
hr {
  border-color: #7da0b8;
}
.big {
  &.el-select {
    width: 450px;
  }
}
.biggest {
  &.el-textarea {
    width: 700px;
  }
}
.el-checkbox__label {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/PrecheckerJudgment.vue